export default __webpack_public_path__ + "static/media/SuperNovel.2804a9c7.png";